<template>
  <div>
    选择医院：
    <el-select v-model="hospital" placeholder="请选择医院">
      <el-option
        v-for="item in hospitalList"
        :key="item.hospitalId"
        :label="item.hospitalName"
        :value="item.hospitalId">
      </el-option>
    </el-select>
    <br>
    用户账号：
    <el-input v-model="account" placeholder="请输入用户账号" clearable maxlength="11" minlength="11"></el-input>
    用户类型：
    <el-select v-model="userType" placeholder="请选择医院">
      <el-option
        v-for="item in userTypeList"
        :key="item.value"
        :label="item.label"
        :value="item.value">
      </el-option>
    </el-select>
    <br>
    <el-button type="primary" @click="addMember">添加成员</el-button>
  </div>
</template>

<script>
import Global from "../Global";

export default {
  name: "AddMember",
  mounted() {
    this.getHospitalList()
  },
  data() {
    return {
      hospitalList: [],
      hospital: '',
      userTypeList: [
        {
          value: 0,
          label: '普通成员'
        },
        {
          value: 1,
          label: '创建者'
        },
        {
          value: 2,
          label: '管理者'
        }
      ],
      userType: null,
      account: ''
    }
  },
  methods: {
    addMember() {
      let hospitalId = this.hospital
      let account = this.account
      let idType = this.userType
      this.axios({
        method: 'POST',
        url: Global.yunyingUrl + '/service-hospital/hospital/addMember',
        data: {
          hospital_id: hospitalId,
          account: account,
          id_type: idType
        }
      }).then(resp => {
        if (resp.data.code === 1000) {
          this.$message.success('添加成员成功')
        } else {
          this.$message.error(resp.data.msg)
        }
      })
    },
    getHospitalList() {
      let that = this
      this.axios({
        method: 'GET',
        url: Global.yunyingUrl + '/service-hospital/hospital/getAllHospital'
      }).then(resp => {
        let data = resp.data
        if (data.code === 1000) {
          that.hospitalList = data.data
        } else {
          this.$message.error(data.msg)
        }
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/hospital_manage/AddMember.vue